import { useEffect, useState } from "react";

// Internal Imports
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import IGroupKey from "../interfaces/IGroupKey";
import { getSexType } from "../services/user";


const useListSexType = () => {

    // States
    const [listTypeSex, setListTypeSex] = useState<IGroupKey[]>([]);
    const [loadingTypeSex, setLoadingTypeSex] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetSexType();
    }, [])

    // Handles
    const handleGetSexType = () => {
        setLoadingTypeSex(true);
        tryCatch(() => {
            getSexType()
                .then((response) => {
                    setListTypeSex(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingTypeSex(false));
        })
    }

    return {
        listTypeSex,
        loadingTypeSex
    }
}


export default useListSexType;